import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';
import { LuCheck } from 'react-icons/lu';

import { cn } from '@/utils/cn';

const Checkbox = React.forwardRef<
    React.ElementRef<typeof CheckboxPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => {
    const isFilled = props.checked === true || props.checked === 'indeterminate';
    return (
        <CheckboxPrimitive.Root
            ref={ref}
            className={cn(
                'peer ring-offset-background focus-visible:ring-ring flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded border transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
                isFilled ? 'border-cocoa-900 bg-cocoa-900' : 'border-cocoa-200 hover:border-cocoa-300 bg-white',
                props.disabled ? 'cursor-not-allowed' : 'cursor-pointer',
                className,
            )}
            {...props}
        >
            <CheckboxPrimitive.Indicator className="flex items-center justify-center text-white">
                {props.checked === 'indeterminate' ? (
                    <div className="h-0.5 w-2.5 rounded-full bg-current" />
                ) : (
                    <LuCheck className="h-3.5 w-3.5" />
                )}
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    );
});
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
